import React from 'react';
import { injectIntl, InjectedIntlProps } from 'react-intl';

type PropType = InjectedIntlProps;

class Footer extends React.Component<PropType> {
    public render() {
        const { intl } = this.props;
        const packageJson = require('../../package.json');

        return (
            <div className="footer">
                <div className="pull-right">
                    ADMIN: <strong>{packageJson.version}</strong>
                </div>
                <div>
                    <strong>{intl.formatMessage({id: 'component.drawer.copyright'})} </strong>{intl.formatMessage({ id: 'common.copyright' })}
                </div>
            </div>
        );
    }
}

export default injectIntl(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.tsx